import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render () {
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom mb-3" light>
                <Container>
                    <div className="col-12 col-sm-8">

                        <NavbarBrand tag={Link} to="/">
                            <h1 className="text-left mb-0"><span id="left">{'{'} </span><span>IF Block</span><span id="right">{'}'}</span></h1>
                            <span className="sub">Helping companies build software Apps and Services</span>
                        </NavbarBrand>
                    </div>
                    <div className="col-12 col-sm-4 d-none d-sm-block">
                        <div className="block"> contact@ifblock.com</div>
                        <div className="block"> 07767 874616</div>
                    </div>
          </Container>
        </Navbar>
      </header>
    );
  }
}



 //<NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
 //           <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
 //             <ul className="navbar-nav flex-grow">
 //               <NavItem>
 //                 <NavLink tag={Link} className="text-dark" to="/">Home</NavLink>
 //               </NavItem>
 //               <NavItem>
 //                 <NavLink tag={Link} className="text-dark" to="/counter">Counter</NavLink>
 //               </NavItem>
 //               <NavItem>
 //                 <NavLink tag={Link} className="text-dark" to="/fetch-data">Fetch data</NavLink>
 //               </NavItem>
 //             </ul>
 //           </Collapse>
